import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setCredentials, setTwoFactorMethod } from '../actions';
import { stringify } from 'hub-http/helpers/params';
export const useRedirect = credentials => {
  const dispatch = useDispatch();
  const history = useHistory();
  const redirectToTwoFactorRequired = useCallback(({
    email,
    token,
    primary,
    secondary,
    backupCodesEnabled
  }) => {
    const {
      loginPortalId,
      loginRedirectUrl
    } = credentials;
    dispatch(setTwoFactorMethod(token, primary, secondary, backupCodesEnabled));
    dispatch(setCredentials({
      email
    }));
    const nextPath = `/two-factor?${stringify({
      loginPortalId,
      loginRedirectUrl
    })}`;
    history.push(nextPath);
  }, [history, dispatch, credentials]);
  const redirectToSuspiciousUser = useCallback(({
    email,
    token
  }) => {
    const {
      loginPortalId,
      loginRedirectUrl
    } = credentials;
    dispatch(setTwoFactorMethod(token, null, null, false));
    dispatch(setCredentials({
      email
    }));
    const nextPath = `/confirm-to-login?${stringify({
      loginPortalId,
      loginRedirectUrl
    })}`;
    history.push(nextPath);
  }, [dispatch, history, credentials]);
  const redirectToSsoRequired = useCallback(({
    hubId
  }) => {
    const nextPath = `/sso?${stringify({
      loginPortalId: hubId,
      required: true
    })}`;
    history.push(nextPath);
  }, [history]);
  return useMemo(() => ({
    redirectToSsoRequired,
    redirectToSuspiciousUser,
    redirectToTwoFactorRequired
  }), [redirectToSsoRequired, redirectToSuspiciousUser, redirectToTwoFactorRequired]);
};